import CryptoJS from 'crypto-js';

export const encryptData = (data: Record<string, any>, secretKey: string): string => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
};

export const decryptData = (encryptedData: string, secretKey: string): Record<string, any> => {
  const decrypted = CryptoJS.AES.decrypt(encryptedData, secretKey).toString(CryptoJS.enc.Utf8);

  return JSON.parse(decrypted);
};

export const encryptLocalData = (secretKey: string, data: any) => {
  const Value = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey + '@123').toString();

  localStorage.setItem(secretKey, Value);
};

export const decryptLocalData = (secretKey: string) => {
  const encryptedData = localStorage.getItem(secretKey) as string;

  if (!encryptedData) return undefined;
  const decrypted = CryptoJS.AES.decrypt(encryptedData, secretKey + '@123').toString(CryptoJS.enc.Utf8);

  return JSON.parse(decrypted);
};
